import {
  Box,
  IconButton,
  // TableBody,
  // TableCell,
  // TableRow,
  styled,
} from "@mui/material";
import debounce from "lodash/debounce";
import { orderBy as _orderBy } from 'lodash';
// import { styled } from "@mui/material";
import { Signature } from "entities/UIModel/Signature";
import {
  useSignatureDispatchProvider,
  useSignatureProvider,
} from "pages/signatures/providers/manage-signature/SignatureProvider";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
// import {
//   borderRadius,
//   colors,
//   defaultStyle,
//   fontSize,
//   fontWeight,
//   letterSpacing,
//   padding,
// } from "theme/defaultStyle";
import { useSignatures } from "utils/context/SignaturesContext";
// import { PERMISSIONS } from "utils/data/enum";
import StewartTable, { StewartTableColumn } from "controls/global/stewart-table/StewartTable";
// import { ManageSignature } from "entities/UIModel/ManageSignature";
// import useFormWrapper from "utils/custom-hooks/useFormWrapper";
import { showToast } from "controls/global/stewart-toast/showToast";
import TooltipCell from "controls/global/stewart-table/TooltipCell";
import { Order } from "utils/sorting";
import { useMyFiles } from "utils/context/MyFilesContext";
import { useGlobalAccess } from "utils/context/GlobalAccessContext";
import { useConfigContext } from "utils/context/ConfigContextProvider";
import AgencySetup from "theme/icons/AgencySetup";
import CustomTooltip from "controls/global/custom-tooltip";
import {
  borderRadius,
  borderSize,
  colors,
  defaultStyle,
  fontSize,
  fontWeight,
  margin,
  padding,
} from "theme/defaultStyle";
import EditSignature from "theme/icons/EditSignature";
import DeleteIcon from "@mui/icons-material/Delete";
import SignatureConfiguration from "../signature-configuration";
import { SignatureConfigurationNode } from "entities/ApiModel/SignatureConfigurationNode";
import { useConfigurationProvider } from "pages/signatures/providers/manage-signature/ConfigurationProvider";
import { selectAllLocationNodes } from "utils/signature/treeView";
import AddSignatureLink from "./AddSignatureLink";
import { IncludeAgencyConfiguration, UIConstants } from "utils/data/enum";
import { getSignatureActionLabels } from "utils/services/utilsService";
import SignatureConfirmationDialog from "../signature-confirmation-dialog/SignatureConfirmationDialog";
import { formatDateRegEx, toBase64 } from "utils/shared";
import { IColumn } from "entities/ApiModel/IColumn";
import CircularProgressWithLabel from "controls/global/circular-progress-with-label/CircularProgressWithLabel";
import StewartTableFooterPaginator from "controls/global/stewart-table/StewartTableFooterPaginator";
import { SignatureSearchCriteria } from "entities/UIModel";
import useSignature from "utils/custom-hooks/useSignature";
import SignatureDialog from "../signature-dialog";
import { getColumnConfig } from "utils/columnsGrid";
import { SignatureRow } from "entities/UIModel/SignatureRow";
// import { usePaginationProvider } from "pages/signatures/providers/manage-signature/PaginationProvider";

interface Props {
  // records: Signature[];
  colsConfig: IColumn[];
}

type SignatureFlowStep = "AGENCY_SETUP" | "ADD_SIGNATURE" | null;

const StyledAddSignatureContainer = styled(Box)({
  marginTop: margin.xlarge1,
});

const EDIT_DEFAULTED_SIGNATURES_MESSAGE = "This signature is defaulted for one or more users.";
const DELETE_SIGNATURE_TITLE_MESSAGE = "Delete this signature ?";
const DELETE_DEFAULTED_SIGNATURES_SUBTITLE_MESSAGE = "This signature is defaulted by one or more users.";


const ProgressWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  zIndex: 1300,
});

const StyledTableContainer = styled(Box)({

  "& table thead th, & table thead .MuiTableCell-root": {
    zIndex: 2,
  },
  "& table tbody tr:last-child td, & table tbody tr:last-child .MuiTableCell-root": {
    background: "#fff",
  },
  "& table tbody tr:hover td": {
    backgroundColor: `${colors.grey10} !important`,
  },
  "& table tbody td, & table tbody .MuiTableCell-root": {
    position: "relative",
    zIndex: 1,
    backgroundColor: "#fff",
  },
  "& > .MuiTableContainer-root > table.MuiTable-root:not(.details-table)": {
    "& > thead": {
      "& th.MuiTableCell-root.MuiTableCell-head": {
        color: colors.grey08,
        fontSize: fontSize.base,
        fontWeight: fontWeight.normal2,
        "& div.MuiBox-root": {
          color: colors.grey08,
          fontSize: fontSize.base,
          fontWeight: fontWeight.normal2,
        },
        "& div.MuiInputBase-root.MuiOutlinedInput-root.MuiOutlinedInput-adornedEnd": {
          border: borderSize.zero,
          borderBottom: `${borderSize.xsmall} solid ${colors.grey15}`,
          borderRadius: 0,
          "&:focus-within": {
            borderBottom: `${borderSize.small} solid ${colors.blue01}`,
          },
          "& fieldset": {
            border: borderSize.zero,
          },
        },
      },
    },
    "& > tbody": {
      "& > tr": {
        "&:hover td": {
          background: colors.grey10,
        },
        "&:last-child": {
          "& > td:not(.emptyCell)": {
            borderBottom: `1px solid ${colors.grey08}`,
          },
          "& > td:not(.emptyCell):first-child": {
            borderBottomLeftRadius: borderSize.zero,
          },
          "& > td:not(.emptyCell):last-child": {
            borderBottomRightRadius: borderSize.zero,
          },
        },
      },
    },
    "& td.MuiTableCell-root.MuiTableCell-body": {
      "& div": {
        color: colors.grey08,
        fontWeight: fontWeight.normal1,
      },
    },
    "& td.MuiTableCell-root.MuiTableCell-footer": {
      borderBottom: defaultStyle.table.border,
      borderBottomLeftRadius: borderRadius.small,
      borderBottomRightRadius: borderRadius.small,
      borderLeft: defaultStyle.table.border,
      borderRight: defaultStyle.table.border,
      padding: padding.xsmall2,
      paddingRight: padding.small2,
    },
  },
  "& .rightColumn": {
    "& span": {
      display: "flex",
      justifyContent: "end",
      paddingRight: padding.small2,
    },
    "& .MuiFormLabel-root.MuiInputLabel-root": {
      textAlign: "end",
    },
  },
});

const SignaturesTableBody = ({ colsConfig }: Props) => {
  const [selectedRowId, setSelectedRowId] = useState(0);
  const [editingSignature, setEditingSignature] = useState<Signature | null>(null);
  const [showEditWarningDialog, setShowEditWarningDialog] = useState(false);
  const [disableConfirmationDialogYes, setDisableConfirmationDialogYes] = useState(false);
  const [ , { getSignatureConfiguration, setColumnDefinition, getSignatures, getSignature, deleteSignature }] = useSignatures();
  const { state: signatureState } = useSignatureProvider();
  const { dispatch: signatureDispatch } = useSignatureDispatchProvider();
  // const { dispatch: setPaginationSignature } = usePaginationProvider();
  const [showSignatureConfig, setShowSignatureConfig] = useState(false);

  const DefaultPage = 1;
  const InitialMessage = "Loading results...";
  const [noRecordsMessage, setNoRecordsMessage] = useState<string[]>([InitialMessage]);
  const [filters, setFilters] = useState<any>(undefined);
  const [sortColumn, setSortColumn] = useState<string | undefined>("signatureImageName");
  const [readyToSearch, setReadyToSearch] = useState<boolean>(false);
  const [, { setRequestTimeoutMs }] = useMyFiles();

  const NO_RECORD_MESSAGE = "There are currently no signatures configured.";
  const [order, setOrder] = React.useState<Order>("desc");
  const FETCHING_DATA_ERROR_MESSAGE = "There was a problem fetching your signatures. Please try again";
  const [orderBy, setOrderBy] = React.useState<keyof Signature | undefined>("signatureName");
  const { generalConfig } = useConfigContext();
  const [{ loadingProgress, isLoading }] = useSignatures();
  const { refreshAllSignaturesStateContext, refreshAllDefaultSignaturesStateContext } = useSignature();
  
  const [userInputDebounceTimeMs, setUserInputDebounceTimeMs] = useState<number>(750);
  const [settingsLoaded, setSettingsLoaded] = useState<boolean>(false);
  const [partialFilterUpdate, setPartialFilterUpdate] = useState<boolean>(false);
  const [nodes, setNodes] = useState<SignatureConfigurationNode[] | null>(null);
  const [flowStep, setFlowStep] = useState<SignatureFlowStep>(null);
  const [showDeleteDialog, setShowDeleteDialog] = useState<boolean>(false);
  const [deleteMessage, setDeleteMessage] = useState<{ title: string; subTitle: string }>({ title: "", subTitle: "" });

  const [ signatures, setSignatures] = useState<Signature[]>([]);
  const [page, setPage] = useState<number>(DefaultPage);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const { dispatch: configurationDispatch } = useConfigurationProvider();
  const [{ selectedAgency: globalAccessAgency }] = useGlobalAccess();
  const {
    state: { mode },
  } = useSignatureProvider();
  const isFirstRender = useRef(true);

  const getFileSearchCriteria = () => {
    // let criteria: any;
    // if (sortColumn) {
    const criteria: SignatureSearchCriteria = {
        // ...criteria,
        sortColumn: sortColumn,
        listCount: rowsPerPage,
        requestedPage: page,
        includeImageData: 1, // 1=include image, 0=exclude image
      };
    // }
    return criteria;
  };

  const showLoader = () => {
    return (
      <ProgressWrapper>
        <CircularProgressWithLabel value={loadingProgress} />
      </ProgressWrapper>
    );
  };
  const getDatabaseSortColumnName = (name: string) => {
    const mappedColumnNames: { [key: string]: string } = {
      signatureImageId: "SignatureImageID",
      signatureName: "SignatureImageName",
      signatureImageName: "SignatureImageName",
      signatureImageDescription: "SignatureImageDescription",
      signatureImageSourceTypeCode: "SignatureImageSourceTypeCode",
      signatureImageFontTypeCode: "SignatureImageFontTypeCode",
      signatureImageFormatTypeCode: "SignatureImageFormatTypeCode",
      signatureImageData: "SignatureImageData",
      signatureLevelTypeCode: "SignatureLevelTypeCode",
      signatureConfiguration: "SignatureConfiguration",
      isDefaulted: "IsDefaulted",
      isDefaultedByOther: "IsDefaultedByOther",
      signatureCreatedDate: "SignatureCreatedDate",
      signatureCreatedByUser: "SignatureCreatedByUser",
      signatureImage: "SignatureImage",
      access: "SignatureLevelTypeCode",
      createdBy: "SignatureCreatedByUser",
      "createdDate/Time": "SignatureCreatedDate",
      currentRow: "CurrentRow",
      currentPage: "CurrentPage",
      totalPages: "TotalPages",
      totalRows: "TotalRows",
    };

    return mappedColumnNames[name] ?? name;
  };

  const handleRequestSort = async (columnName: any, disableToggling: boolean = false) => {
    let sortBy = getDatabaseSortColumnName(columnName);
    if (!disableToggling && sortColumn === sortBy) {
      sortBy = `-${sortBy}`;
    }

    setOrder(sortBy.startsWith("-") ? "desc" : "asc");
    setOrderBy(columnName.replace("-", "") as keyof Signature);
    setSortColumn(sortBy);
  };

  const getDefaultFilters = (advanced: boolean): SignatureSearchCriteria => {
    const sortColumn = "-SignatureImageName";

    const defaultFilters: SignatureSearchCriteria = {
      listCount: rowsPerPage,
      requestedPage: page,
      // isInitialLoad: false,
      sortColumn: sortColumn,
    };
    return defaultFilters;
  };

  const performSearch = async () => {
    // const criteria = getFileSearchCriteria();
    // let documents: Signature[] | undefined;

    // try {
    //   const result = await getSignatures(selectedAgency[0]?.CompanyID, criteria);
    //   setSignatures(result);
    //   if (!result?.length) {
    //     setNoRecordsMessage([NO_RECORD_MESSAGE]);
    //   }
    // } catch (error) {
    //   console.error("Error fetching data:", error);
    //   showToast({
    //     type: "error",
    //     title: FETCHING_DATA_ERROR_MESSAGE,
    //   });
    // }
    getPageSignatures(); 
  };

  const canSearch = (): boolean => {
    return !partialFilterUpdate && filters !== undefined && Object.values(filters).length > 0;
  };

  const [isSignatureConfiguration, setIsSignatureConfiguration] = useState<boolean>(false);
  const [currentSignature, setCurrentSignature] = useState<Signature | null>(null);

  const handleRequestEdit = (signature: Signature) => {
    setSelectedRowId(signature.signatureImageID);
    if (signature.isDefaulted) {
      setDisableConfirmationDialogYes(false);
      setShowEditWarningDialog(true);
    } else {
      debouncedConfirmEdit(signature.signatureImageID, signature.integrationKey);
    }
  };
  
  const handleConfirmEdit = async (id?: number, integrationKey?: string) => {
    setDisableConfirmationDialogYes(true);
    setShowEditWarningDialog(false);
    id = id ? id : selectedRowId;
    if (id && integrationKey) {
      signatureDispatch({
        type: "OPEN",
        mode: "EDIT",
      });

      const signature = await getSignature(id, integrationKey, IncludeAgencyConfiguration.Yes);
      setEditingSignature(signature);
    }
  };

  const debouncedConfirmEdit = useMemo(
    () =>
      debounce((id: number, integrationKey: string) => {
        handleConfirmEdit(id, integrationKey);
      }, 1000),
    [],
  );
  const handleAgencySetupNext = () => {
    setShowSignatureConfig(false);
    setFlowStep(null);
  };

  const handleOpenAgencySetup = async (id: number, integrationKey: string) => {
    signatureDispatch({
      type: "EDIT",
      mode: "EDIT",
    });
    setFlowStep(null);
    setShowSignatureConfig(true);
    const signature = await getSignature(id, integrationKey, IncludeAgencyConfiguration.No);

    if (signature) {
      setCurrentSignature(signature); // Store the signature
      const actionConfig = getSignatureActionLabels(signature.isModify ?? false);
      setIsSignatureConfiguration(actionConfig.isFieldDisabled);
    }
    setNodes(signature.signatureConfiguration ? [signature.signatureConfiguration] : null);
  };

  const handleCancelEdit = () => {
    setSelectedRowId(0);
    setShowEditWarningDialog(false);
    setIsSignatureConfiguration(false);
  };

  const handleDelete = (signature: Signature) => {
    setDisableConfirmationDialogYes(false);
    setSelectedRowId(signature.signatureImageID);
    setShowDeleteDialog(true);
    setDeleteMessage({
      title: DELETE_SIGNATURE_TITLE_MESSAGE,
      subTitle: signature.isDefaulted ? DELETE_DEFAULTED_SIGNATURES_SUBTITLE_MESSAGE : "",
    });
  };

  const handlePageChange = async (page: number) => {
    setPage(page);
  };

  const handleRowsPerPageChange = async (count: number) => {
    // setRowsPerPageSetting(count);
    setRowsPerPage(count);
    setPartialFilterUpdate(false);
    setPage(DefaultPage);
  };

  const handleAddSignatureClick = async () => {
    setFlowStep("ADD_SIGNATURE");
    setIsSignatureConfiguration(false);

    // Set the close handler in context
    configurationDispatch({
      type: "SET_CLOSE_SIGNATURE_CONFIG_MODAL_HANDLER",
      onClose: handleCloseSignatureConfigModal,
    });

    setShowSignatureConfig(true);
    await initTree();
  };

  const handleDeleteOk = async () => {
    if (!selectedRowId) throw new Error("Delete Signature: Missing SignatureId.");

    setDisableConfirmationDialogYes(true);
    let result = await deleteSignature(selectedRowId);
    if (result?.success) {
      showToast({
        type: "success",
        title: UIConstants.SIGNATURE_DELETE_SUCCESS_MESSAGE.toString(),
      });

      refreshAllSignaturesStateContext(globalAccessAgency[0]?.CompanyID);
      refreshAllDefaultSignaturesStateContext(globalAccessAgency[0]?.CompanyID);
      getPageSignatures();
    } else {
      showToast({
        type: "error",
        title: UIConstants.SIGNATURE_DELETE_ERROR_MESSAGE.toString(),
      });
    }
    setSelectedRowId(0);
    setShowDeleteDialog(false);
  };

  const handleDeleteCancel = () => {
    setSelectedRowId(0);
    setShowDeleteDialog(false);
  };

  const handleCloseSignatureConfigModal = () => {
    setShowSignatureConfig(false);
    setFlowStep(null);
    setCurrentSignature(null); // Reset current signature
    signatureDispatch({
      type: "CLOSE",
    });
    configurationDispatch({
      type: "RESET",
    });
    setNodes(null);
  };

  const getModalTitle = () => {
    if (flowStep === "ADD_SIGNATURE") {
      return " Assign Agency Access to New Signature ";
    }

    const signature = currentSignature || editingSignature;

    if (!signature) {
      return "View Agency Access"; // Fallback title
    }

    const actionConfig = getSignatureActionLabels(signature.isModify ?? false);
    return actionConfig.agencyModalTitle;
  };

  const getPageSignatures = async() => {

      try {
        const criteria = getFileSearchCriteria();
        const agencyID = globalAccessAgency[0]?.CompanyID;
        const result = await getSignatures(agencyID, criteria, false);
        setSignatures(result);
        if (!result?.length) {
          setNoRecordsMessage([NO_RECORD_MESSAGE]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        showToast({
          type: "error",
          title: FETCHING_DATA_ERROR_MESSAGE,
        });
      }    
  }
  
  
  useEffect(() => {
    // setPaginationSignature({ type: PaginationProviderActionType.INIT_SIGNATURE_GRID });
    const defaultFilters = getDefaultFilters(false);
    setFilters(defaultFilters);
  }, []);

  // // get all Signatures without including images
  // useEffect(() => {
  //   refreshAllSignaturesStateContext(globalAccessAgency[0]?.CompanyID);
  // }, [globalAccessAgency])

  // get signatures for a single page, including image
  useEffect(() => {
    refreshAllSignaturesStateContext(globalAccessAgency[0]?.CompanyID);
    refreshAllDefaultSignaturesStateContext(globalAccessAgency[0]?.CompanyID);

    // skip 1st run 
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    getPageSignatures(); // 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalAccessAgency]);  

  useEffect(() => {
    if (readyToSearch) {
      const search = async () => {
        await performSearch();
        setReadyToSearch(false);
      };

      search();
    }
  }, [readyToSearch]);

  const initTree = useCallback(async () => {
    let data: SignatureConfigurationNode | undefined;

    data = await getSignatureConfiguration();
    if (!data) {
      console.warn("Signature configuration node is undefined");
      return;
    }

    if (globalAccessAgency?.length && globalAccessAgency[0]?.CompanyID) {
      data.Children = data.Children?.filter((c) => c.ID === globalAccessAgency[0].CompanyID);
    }

    if (mode === "ADD") {
      selectAllLocationNodes(data);
      data.Expanded = false;
    }
    setNodes(Array.isArray(data) ? data : [data]);
  }, [getSignatureConfiguration, mode, configurationDispatch, globalAccessAgency]);

  useEffect(() => {
    if (mode === "ADD" && showSignatureConfig) {
      initTree();
    }
  }, [showSignatureConfig, mode]);
  const loadSettings = async () => {
    const debounceTime = generalConfig.userInputDebounceTimeMs;
    const timeoutMs = generalConfig.filesSearchTimeoutMs;

    if (debounceTime) {
      setUserInputDebounceTimeMs(debounceTime);
    }
    if (timeoutMs) {
      setRequestTimeoutMs(timeoutMs);
    }
  };
  const debounceSetReadyToSearch = useCallback(
    debounce(() => setReadyToSearch(true), userInputDebounceTimeMs),
    [userInputDebounceTimeMs],
  );

  useEffect(() => {
    if (editingSignature) {
      if (signatureState.open) {
        signatureDispatch({
          type: "OPEN",
          mode: "EDIT",
          signatureID: editingSignature.signatureImageID,
          signatureName: editingSignature.signatureImageName,
          signatureDescription: editingSignature.signatureImageDescription,
          signatureFile: editingSignature.signatureImageData,
          fontFamilyID: editingSignature.signatureImageFontTypeCode,
          imageType: editingSignature.signatureImageFormatTypeCode,
          imageSource: editingSignature.signatureImageSourceTypeCode,
          signatureLevelTypeCode: editingSignature.signatureLevelTypeCode,
          isDefaultedByOther: editingSignature.isDefaultedByOther,
          isModify: editingSignature.isModify,
        });
      }
      setEditingSignature(null);
    }
  }, [editingSignature]);

  useEffect(() => {
    if (!signatureState.open) {
      setSelectedRowId(0);
    }
  }, [signatureState]);

  const handleColumnsModified = (updatedCols: StewartTableColumn<any>[]) => {
    // const colsWithPosition = updatedCols.map((col, index) => ({
    //   field: col.field,
    //   position: index,
    // }));

    // colsWithPosition.forEach((col) => {
    //   setColumnDefinition([col.field as any], "position", col.position);
    // });
  };

  const handleColumnResize = (column: any, newWidth: number) => {
    if (column && newWidth > 0) {
      setColumnDefinition([column], "width", Math.floor(newWidth));
    }
  };

  const DEFAULT_COLUMNS: StewartTableColumn<any>[] = _orderBy([
    {
      field: "signatureName",
      valueGetter: (row: Signature) => {
        return (
          <Box
            sx={{
              cursor: "pointer",
            }}
          >
            <TooltipCell title={row.signatureImageName || ""} />
          </Box>
        );
      },
      ...getColumnConfig<SignatureRow>(colsConfig, "signatureName"),
    },
    {
      field: "signatureImage",
      valueGetter: (row: Signature) => {
        return (
          <Box sx={{ width: 250, height: 44, overflow: "hidden" }}>
            <img
              src={toBase64(row.signatureImageData) || ""}
              alt="Signature"
              style={{ width: "100%", height: "100%", objectFit: "contain", objectPosition: "left" }}
            />
          </Box>
        );
      },
      ...getColumnConfig<SignatureRow>(colsConfig, "signatureImage"),
    },
    {
      field: "signatureLevelTypeCode",
      valueGetter: (row: Signature) => {
        return (
          <Box>
            <TooltipCell title={row.signatureLevelTypeName || ""} />
          </Box>
        );
      },
      ...getColumnConfig<SignatureRow>(colsConfig, "signatureLevelTypeCode"),
    },
    {
      field: "createdBy",
      valueGetter: (row: Signature) => {
        return (
          <Box>
            <TooltipCell title={row.signatureCreatedByUser || ""} />
          </Box>
        );
      },
      ...getColumnConfig<SignatureRow>(colsConfig, "createdBy"),
    },
    {
      field: "createdDateTime",
      valueGetter: (row: Signature) => {
        return (
          <Box>
            <TooltipCell title={row.signatureCreatedDate ? formatDateRegEx(row.signatureCreatedDate) || "" : ""} />
          </Box>
        );
      },
      ...getColumnConfig<SignatureRow>(colsConfig, "createdDateTime"),
    },
    {
      field: "Actions",
      name: "",
      sortable: false,
      sticky: true,
      width: 200,
      draggable: false,
      resizable: false,
      valueGetter: (row: Signature) => {
        const signatureActionConfig = getSignatureActionLabels(row.isModify ?? false);
        return (
          <>
            <CustomTooltip
              title={signatureActionConfig.agencyIconLabel}
              placement="top"
              arrow
            >
              <IconButton
                className="actionButton"
                sx={{ color: colors.blue01, height: "7px", width: "45px" }}
                onClick={() => handleOpenAgencySetup(row.signatureImageID, row.integrationKey)}
              >
                <AgencySetup />
              </IconButton>
            </CustomTooltip>
            <CustomTooltip
              title={signatureActionConfig.signatureIconLabel}
              placement="top"
              arrow
              onClick={() => handleRequestEdit(row)}
            >
              <IconButton
                className="actionButton"
                sx={{ color: colors.blue01, height: "7px", width: "45px" }}
              >
                <EditSignature />
              </IconButton>
            </CustomTooltip>

            <CustomTooltip
              title={"Delete"}
              placement="top"
              arrow
            >
              <span>
                <IconButton
                  className="actionButton"
                  sx={{
                    color: colors.blue01,
                    height: "7px",
                    width: "45px",
                    "&.Mui-disabled": {
                      color: colors.blue01,
                      opacity: 0.5,
                    },
                  }}
                  onClick={() => handleDelete(row)}
                  disabled={signatureActionConfig.isFieldDisabled}
                >
                  <DeleteIcon />
                </IconButton>
              </span>
            </CustomTooltip>
          </>
        );
      },
    },
  ], 'position');

  useEffect(() => {
    const init = async () => {
      await loadSettings();
      setSettingsLoaded(true);
    };

    init();
  }, []);

  useEffect(() => {
    // setPaginationSignature({
    //   type: PaginationProviderActionType.SET_SIGNATURE_GRID,
    //   signaturePagination: {
    //     page: page,
    //     rowsPerPage: rowsPerPage,
    //     sortColumn: sortColumn,
    //   }
    // });    
    if (canSearch()) {
      if (partialFilterUpdate) {
        setPartialFilterUpdate(false);
      }

      debounceSetReadyToSearch();
    }
  }, [filters, page, sortColumn, settingsLoaded, rowsPerPage, page]);

  return (
    <>
      <StyledTableContainer>
        <StewartTable
          name="Signatures"
          cols={DEFAULT_COLUMNS}
          rows={signatures || []} //{records}
          useDbPagingSorting={true}
          showActionRow={false}
          orderBy={orderBy}
          order={order}
          onRequestSort={handleRequestSort}
          noRowsMessage={noRecordsMessage}
          onColumnResize={handleColumnResize}
          onColumnsModified={handleColumnsModified}
          columnsUrl="signatures"
          autoHeight
          page={page}
          rowsPerPage={rowsPerPage}
        />
        {signatures.length > 0 && (
          <div style={{marginTop:"20px"}}>
          <StewartTableFooterPaginator
            totalRows={signatures[0]?.totalRows ?? 0} // records.length}
            rowsPerPage={rowsPerPage}
            page={page}
            totalPages={signatures[0]?.totalPages ?? 0}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
          </div>
        )}
      </StyledTableContainer>
      <SignatureDialog refreshPage={getPageSignatures}/>
      {isLoading && showLoader()}
      <SignatureConfirmationDialog
        width={530}
        isOpen={showDeleteDialog}
        title={deleteMessage.title}
        subtitle={deleteMessage.subTitle}
        iconType="delete"
        onPrimaryAction={async () => await handleDeleteOk()}
        primaryButtonText={"Delete"}
        primaryButtonColor="primary"
        disablePrimaryButton={disableConfirmationDialogYes}
        onSecondaryAction={handleDeleteCancel}
        secondaryButtonText={"Cancel"}
        disableSecondaryButton={false}
        showCloseIcon={true}
        onClose={handleDeleteCancel}
      />
      {showEditWarningDialog && (
        <SignatureConfirmationDialog
          width={550}
          iconType={"warning"}
          title={EDIT_DEFAULTED_SIGNATURES_MESSAGE}
          isOpen={showEditWarningDialog}
          onPrimaryAction={async () => await handleConfirmEdit()}
          onSecondaryAction={handleCancelEdit}
          disablePrimaryButton={disableConfirmationDialogYes}
          primaryButtonText={"Continue"}
          secondaryButtonText={"Cancel"}
          onClose={handleCancelEdit}
        />
      )}
      {showSignatureConfig && (
        <SignatureConfiguration
          nodes={nodes}
          showNext={flowStep === "ADD_SIGNATURE"}
          onNext={handleAgencySetupNext}
          onClose={handleCloseSignatureConfigModal}
          title={getModalTitle()}
          setFlowStep={(step: string) => setFlowStep(step as SignatureFlowStep)}
          setShowSignatureConfig={setShowSignatureConfig}
          isSignatureConfigurationDisabled={isSignatureConfiguration}
          refreshPage={getPageSignatures}
        />
      )}
      <StyledAddSignatureContainer>
        <AddSignatureLink onClick={handleAddSignatureClick} />
      </StyledAddSignatureContainer>
    </>
  );
};

export default SignaturesTableBody;
